import React, { useState, useEffect, useMemo } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import CombinedSchedules from 'schedules/schedules_combined.json';

const localizer = momentLocalizer(moment);
// const FirstDayThisMonth = new Date(
//   new Date().getFullYear(),
//   new Date().getMonth(),
//   1
// );
const Today = new Date();

const EventCalendar = () => {
  const { views } = useMemo(() => ({
    views: [Views.AGENDA, Views.MONTH, Views.WEEK, Views.DAY],
  }));
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  // Load events from a data source (e.g., an API or local storage)
  useEffect(() => {
    const initEvents = () => {
      const evts = [];
      CombinedSchedules.forEach((event) => {
        const date = new Date(event.date);

        const startTime = convertTo24HourFormat(event.startTime);

        const endTime = convertTo24HourFormat(event.finishTime);

        const start = new Date(
          event.date
            .concat('T')
            .concat(startTime.hour)
            .concat(':')
            .concat(startTime.minute)
            .concat(':00')
        );
        const end = new Date(
          event.date
            .concat('T')
            .concat(endTime.hour)
            .concat(':')
            .concat(endTime.minute)
            .concat(':00')
        );

        // const end = new Date(
        //   date.getFullYear(),
        //   date.getMonth(),
        //   date.getDay(),
        //   endTime.hour,
        //   endTime.minute
        // );

        evts.push({
          id: event.id,
          date: date,
          title: event.activity,
          start: start,
          end: end,
          location: event.location,
          booking: event.bookingNo,
        });
      });

      return evts;
    };

    // Replace this with your actual data loading logic
    const initialEvents = initEvents();

    setEvents(initialEvents);
  }, []);

  const convertTo24HourFormat = (timeString) => {
    const [time, period] = timeString.split(' ');
    const [hour, minute] = time.split(':');
    let formattedHour = parseInt(hour);

    if (period === 'PM') {
      formattedHour += 12;
    }

    return { hour: formattedHour, minute: minute };
  };

  const handleEventSelect = (event) => {
    setSelectedEvent(event);
    setIsDialogOpen(true);
    setIsEditMode(true);
  };

  const handleEventCreate = () => {
    setSelectedEvent(null);
    setIsDialogOpen(true);
    setIsEditMode(false);
  };

  const handleEventSave = () => {
    if (isEditMode) {
      // Update the existing event
      const updatedEvents = events.map((event) =>
        event.id === selectedEvent.id ? selectedEvent : event
      );
      setEvents(updatedEvents);
    } else {
      // Create a new event
      const newEvent = {
        id: events.length + 1,
        title: selectedEvent.title,
        start: selectedEvent.start,
        end: selectedEvent.end,
      };
      setEvents([...events, newEvent]);
    }
    setIsDialogOpen(false);
  };

  const handleEventDelete = () => {
    const updatedEvents = events.filter(
      (event) => event.id !== selectedEvent.id
    );
    setEvents(updatedEvents);
    setIsDialogOpen(false);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setIsEditMode(false);
  };

  const handleEventChange = (field, value) => {
    setSelectedEvent((prevEvent) => ({
      ...prevEvent,
      [field]: value,
    }));
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={events}
        defaultDate={Today}
        defaultView={Views.MONTH}
        startAccessor='start'
        endAccessor='end'
        style={{ height: 600, fontSize: '0.8rem' }}
        onSelectEvent={handleEventSelect}
        eventPropGetter={(events) => {
          const backgroundColor =
            events.title === 'Volleyball' || events.title === 'volleyball'
              ? 'darkred'
              : events.title === 'Pickleball' || events.title === 'pickleball'
              ? 'darkblue'
              : events.title === 'Taichi' || events.title === 'taichi'
              ? 'darkgreen'
              : 'white';
          return { style: { backgroundColor, color: 'white' } };
        }}
      />
      {/* <Button variant='contained' onClick={handleEventCreate}>
        Create Event
      </Button> */}
      <Dialog open={isDialogOpen} onClose={handleDialogClose}>
        <DialogTitle>
          {isEditMode ? 'Display Event' : 'Create Event'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label='Event Title'
                value={selectedEvent?.title || ''}
                // onChange={(e) => handleEventChange('title', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='Booking Number'
                type='number'
                value={selectedEvent?.booking || ''}
                // onChange={(e) => handleEventChange('title', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='Start Date'
                type='date'
                value={selectedEvent?.date?.toISOString().slice(0, 10) || ''}
                // onChange={(e) =>
                //   handleEventChange('start', new Date(e.target.value))
                // }
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='End Date'
                type='date'
                value={selectedEvent?.date?.toISOString().slice(0, 10) || ''}
                // onChange={(e) =>
                //   handleEventChange('end', new Date(e.target.value))
                // }
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='Start Time'
                type='time'
                value={selectedEvent?.start?.toTimeString().slice(0, 8) || ''}
                // onChange={(e) =>
                //   handleEventChange('start', new Date(e.target.value))
                // }
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='End Time'
                type='time'
                value={selectedEvent?.end?.toTimeString().slice(0, 8) || ''}
                // onChange={(e) =>
                //   handleEventChange('end', new Date(e.target.value))
                // }
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label='Event Location'
                value={selectedEvent?.location || ''}
                // onChange={(e) => handleEventChange('title', e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* {isEditMode && (
            <Button color='secondary' onClick={handleEventDelete}>
              Delete
            </Button>
          )} */}
          <Button variant='contained' onClick={handleDialogClose}>
            Close
          </Button>
          {/* <Button variant='contained' onClick={handleEventSave}>
            Save
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EventCalendar;
